import { BaseRepository } from '../BaseRepository';
import { BffAuthenticatedApiClient } from '../../clients/BffAuthenticatedApiClient';
import type { HttpResponse } from '../../http/HttpClient';

const NAME = 'dynamicForm';

/**
 * Repository for dynamic form data operations.
 * Handles fetching dynamic form options from BFF endpoints.
 */
export class DynamicFormRepository extends BaseRepository {
  static override readonly name = NAME;

  constructor() {
    super(BffAuthenticatedApiClient.getInstance());
  }

  /**
   * Fetch dynamic form options from a given API endpoint
   *
   * @param apiPath - The API endpoint path to fetch from
   * @param pathParams - Optional path parameters for URL substitution
   * @returns Promise with the form options data
   */
  fetchOptions(
    apiPath: string,
    pathParams?: Record<string, string>,
  ): Promise<HttpResponse<Array<Record<string, unknown>>>> {
    return this.apiClient.get<Array<Record<string, unknown>>>(
      apiPath,
      {
        pathParams,
      },
    );
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: DynamicFormRepository;
  }
}
